import React from 'react';
import { Text, View } from 'react-native-web';
import { img_android_screen_simple_keypad, img_scr_numeric_1234 } from '../../../../utils/ImagesManagementUtils';
import { Android } from '../../../../utils/DictionaryManagementUtils';
import FullPageSimulator from '../FullPageSimulator';
import SingleSquareCode from '../../AuxiliaryComponent/MixComponent/SingleSquareCode';
import { getRegularFont } from '../../../../utils/Utils';

//= ========================================================================
const OtpCodeFP = ({
  globJSON,
  simPlatform,
  notSkipped,
  TopTitle,
  withErrorTxt,
  slideshowRefs,
}) => {
  const { colors } = globJSON.configurations.theme;
  const { auth } = globJSON.configurations.launch;
  const myStyles = {
    container: {
      alignSelf: 'center',
      flexDirection: 'row',
    },
    opacityStyle: {
      width: 240,
      height: simPlatform === Android ? 427 : 520,
      marginTop: 30,
      marginLeft: 0,
      position: 'absolute',
      backgroundColor: '#fff',
      opacity: 0.5,
    },
    lblError: {
      fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
      fontSize: 8.1,
      textAlign: 'center',
      color: colors.negative_color,
    },

  };

  return (
    <FullPageSimulator
      globJSON={globJSON}
      simPlatform={simPlatform}
      headlineText={auth.enter_the_code_you_just_received}
      TopTitle={TopTitle}
      keyboardType="numbersKeyboard"
      WithImageBackground={simPlatform === Android ? img_android_screen_simple_keypad : img_scr_numeric_1234}
      slideshowRefs={slideshowRefs}
    >
      <View style={myStyles.container}>
        <SingleSquareCode
          globJSON={globJSON}
          simPlatform={simPlatform}
          inputNum="4"
          withErrorTxt={withErrorTxt}
        />
        <SingleSquareCode
          globJSON={globJSON}
          simPlatform={simPlatform}
          inputNum="0"
          withErrorTxt={withErrorTxt}
        />
        <SingleSquareCode
          globJSON={globJSON}
          simPlatform={simPlatform}
          inputNum="5"
          withErrorTxt={withErrorTxt}
        />
        <SingleSquareCode
          globJSON={globJSON}
          simPlatform={simPlatform}
          inputNum="2"
          withErrorTxt={withErrorTxt}
        />

      </View>
      {withErrorTxt
            && (
            <Text style={myStyles.lblError}>
              {withErrorTxt}
            </Text>
            )}
      {!notSkipped && <View style={myStyles.opacityStyle} />}
    </FullPageSimulator>
  );
};
export default OtpCodeFP;
